module.exports = __webpack_public_path__ + "img/lock_room_icon.8c46c481.svg";